module.exports = __webpack_public_path__ + "static/media/talkmore-icons.6ac70c60.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/talkmore-icons.ttf
// module id = 120
// module chunks = 0